var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEducation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.8771 31.4357L1.07422 19.7559L27.556 8.07715L53.0871 19.4846L26.8771 31.4357Z",
    fill: "#F48000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5671 19.0771H50.9375V36.1887H52.5671V19.0771Z",
    fill: "#F48000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5617 37.6142C50.5617 37.6142 48.5406 41.8916 49.3559 48.4104H52.2446V37.0029C52.2446 37.0029 50.5617 37.9536 50.5623 37.6142H50.5617Z",
    fill: "#FFE4C6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1464 37.6142C53.1464 37.6142 55.2014 41.8916 54.3866 48.4104H51.4297V37.0029C51.4297 37.0029 53.147 37.9536 53.1464 37.6142Z",
    fill: "#FFE4C6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3331 36.7994C54.3331 35.3751 53.1778 34.2197 51.7535 34.2197C50.3292 34.2197 49.1738 35.3751 49.1738 36.7994C49.1738 38.2237 50.3275 39.3796 51.7535 39.3796C53.1795 39.3796 54.3331 38.2237 54.3331 36.7994Z",
    fill: "#FFE4C6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3132 25.6375C16.4352 27.8737 21.7872 30.282 26.9093 32.5182L41.7026 25.9816C41.741 29.6512 41.7789 33.3209 41.8173 36.9906C41.8173 36.9906 28.9161 47.5982 11.2559 36.7612V25.6123L11.3132 25.6375Z",
    fill: "#FFE4C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducation);
export default __webpack_public_path__ + "static/media/Education.b1c790a4d41ff679a421685f7c391d55.svg";
export { ForwardRef as ReactComponent };